module.exports = __webpack_public_path__ + "img/step-active2.2a4301ee.png";